import type { Socket } from 'socket.io-client'
import type { ClientToServerEvents, ServerToClientEvents } from '~/types/socket'

type GameSocket = Socket<ServerToClientEvents, ClientToServerEvents>

type SocketHandler = (...args: any[]) => void

export const bindSocketListener = (
    socket: GameSocket,
    event: string,
    handler: SocketHandler
): (() => void) => {
    socket.off(event as any, handler as any)
    socket.on(event as any, handler as any)

    return () => {
        socket.off(event as any, handler as any)
    }
}
